import React from 'react';
import { Link } from 'react-router-dom';
import './FeedUser.css';
import {encrypt} from "../../../helpers/CryptoJs"
import iconPath from "./../../../helpers/iconHelper";

const FeedUser = (props) => { 
    const { post_user , post_date } = props;
    let ownimage = '';
    if(props.ownimage !== undefined){
        ownimage = (props.ownimage == 'yes') ? 'ownimage' : '';
    }
     
    return (
        <div>
            <div className="list_ico">
            {
                (post_user.post_user_image != '') ? 
                    <img className={(post_user.post_user_membership == 'GOLD') ? "gold_user "+ownimage : ownimage} src={post_user.post_user_image} /> :
                     <img src={iconPath['DEFAULTUSER']}/>
            } 
            </div>
            <div className="list_details">  
            {
                (Object.keys(post_user).length > 0) ? 
                <Link to={`/user/${encrypt(post_user.post_user_id)}`}><h4>{post_user.post_user_name}</h4></Link>
                : null
            }   
               
            <p> {post_date}</p>
            </div>
        </div>
    );
};

export default FeedUser;